<rt-dropdown class="dropdown">
  <rt-dropdown-header *ngIf="showHeader" class="header">
    <rt-icon-button
      prefix
      (click)="$event.preventDefault(); goBack($event)"
      variant="plain"
      iconName="arrow-back"
      size="small"
      shape="square"
    >
    </rt-icon-button>
    {{ placeholderCategoryTranslationMap[category].name }}
  </rt-dropdown-header>
  <rt-dropdown-item
    *ngFor="let placeholder of placeholdersByCategory; let isLast = last; trackBy: trackByName"
    [insertPlaceholder]="placeholder.id"
    [insertPlaceholderTarget]="activeTarget!"
    [isSelected]="placeholder.id === active?.id"
    (click)="select.emit(placeholder)"
    layout-vertical
  >
    <div layout layout-space-between>
      <div layout-vertical>
        <rt-heading variant="heading">
          <span class="preserve-whitespace" margin-right-small-xx text-primary>[ </span>
          {{ withoutBrackets(placeholder.id) }}
          <span class="preserve-whitespace" margin-left-small-xx text-primary> ]</span>
        </rt-heading>
        <span
          [innerHTML]="placeholder.interpolated ? placeholder.value : placeholder.data.description"
          class="description info-dropdown-text"
        >
        </span>
      </div>
    </div>
  </rt-dropdown-item>
</rt-dropdown>
